import { CircularProgress, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import AppPrimaryButton from "../../appComponents/buttons/AppPrimaryButton";

export default function StartButton() {
  // useSelector allows you to access the data from the slice
  const { config, configLoading, configError } = useSelector(
    (state: any) => state.ConfigSlice
  );

  return (
    <>
      {configError ? (
        <Typography>There was a error get the data.</Typography>
      ) : (
        <>
          {configLoading ? (
            <CircularProgress />
          ) : (
            <AppPrimaryButton
              style={{ marginBottom: 20, marginTop: 5 }}
              size={"large"}
              to={`/virtual/${config.startScene}`}
            >
              Start Experience
            </AppPrimaryButton>
          )}
        </>
      )}
    </>
  );
}
